export const trainings = [
  {
    id: 1,
    img: "/training/lcw.png",
    title: "Agile Metodolijisi/Scrum",
    trainer: "Bülent Turhan",
    link: "",
  },
  {
    id: 2,
    img: "/training/lcw.png",
    title: "Öğrenmeyi Öğrenmek",
    trainer: "Çiğdem Durmuş",
    link: "",
  },
  {
    id: 6,
    img: "/training/udemy.png",
    title: "C# Kurumsal Backend-1",
    trainer: "Engin Demiroğ",
    link: "https://www.udemy.com/certificate/UC-3TXHEGJ9/",
  },
  {
    id: 3,
    img: "/training/udemy.png",
    title: "C# Kurumsal Backend-2",
    trainer: "Engin Demiroğ",
    link: "https://www.udemy.com/certificate/UC-ZLNAWIL5/",
  },
  {
    id: 4,
    img: "/training/udemy.png",
    title: "C# Kurumsal Backend-4",
    trainer: "Engin Demiroğ",
    link: "https://www.udemy.com/certificate/UC-232D33LU/",
  },
  {
    id: 5,
    img: "/training/udemy.png",
    title: "Sql PL/SQL",
    trainer: "Cihan Özhan",
    link: "https://www.udemy.com/certificate/UC-5238c1f2-38c3-4a51-b7c9-91ea9828a3f9/",
  },
  {
    id: 7,
    img: "/training/udemy.png",
    title: "Unity C# Mobile Game Development",
    trainer: "GameDev.tv",
    link: "https://www.udemy.com/certificate/UC-05abcf62-8dec-470b-b7aa-3c0684e3c71f/",
  },
  {
    id: 8,
    img: "/training/udemy.png",
    title: "Web Desing for Beginners Html/Css",
    trainer: "Brad Schiff",
    link: "https://lcwaikikiakademi.udemy.com/certificate/UC-68550ac4-83ff-4d42-82d4-a2d1e19d860a/",
  },
  {
    id: 9,
    img: "/training/udemy.png",
    title: "Unity C# Mobile Game Development ",
    trainer: "GameDev.tv",
    link: "https://www.udemy.com/certificate/UC-05abcf62-8dec-470b-b7aa-3c0684e3c71f/",
  },
];
